import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const usePrevious = (state)=>{
    const ref = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)();
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
};
export { usePrevious };
